export default __webpack_public_path__ + "static/video-56eb592bce9721cf513af8cc613c64dc.png";